export const hbConfig = {
    main: {
        biddersMap: {
            adwile: "2223826",
        },
        adUnits: [
            {
                code: "adfox_17408189579286666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32822",
                        },
                    },
                ],
            },
            {
                code: "adfox_1740818984321666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32821",
                        },
                    },
                ],
            },
            {
                code: "adfox_17408190071095666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32820",
                        },
                    },
                ],
            },
            {
                code: "adfox_17408193689367666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32818",
                        },
                    },
                ],
            },
        ],
        timeout: 700,
        trustedOwners: [123456, 111111],
    },
    48306: {
        biddersMap: {
            adwile: "2223826",
        },
        adUnits: [
            {
                code: "adfox_17408189579286666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32822",
                        },
                    },
                ],
            },
            {
                code: "adfox_1740818984321666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32821",
                        },
                    },
                ],
            },
            {
                code: "adfox_17408190071095666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32820",
                        },
                    },
                ],
            },
            {
                code: "adfox_17408193689367666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "32818",
                        },
                    },
                ],
            },
        ],
        timeout: 700,
        trustedOwners: [123456, 111111],
    },
    5: {
        biddersMap: {
            adwile: "2223826",
        },
        adUnits: [
            {
                code: "adfox_17664740032373666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "36128",
                        },
                    },
                ],
            },
            {
                code: "adfox_17664740027083666",
                bids: [
                    {
                        bidder: "adwile",
                        params: {
                            placementId: "36129",
                        },
                    },
                ],
            },
        ],
        timeout: 700,
        trustedOwners: [123456, 111111],
    },
};
